import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
import Link from "next/link";
export const CountLink = (param)=>{
    let { label , count =0 , href  } = param;
    const containerStyle = {
        display: "flex",
        gap: "4px"
    };
    const content = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                children: label
            }),
            /*#__PURE__*/ _jsx(Count, {
                children: count.toLocaleString()
            })
        ]
    });
    if (href) {
        return /*#__PURE__*/ _jsx(Link, {
            href: href,
            style: containerStyle,
            children: content
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        style: containerStyle,
        children: content
    });
};
const Text = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.secondary,
        ...theme.typography.body1,
        [theme.breakpoints.down("sm")]: {
            ...theme.typography.body2
        },
        ":hover": {
            textDecoration: "underline",
            cursor: "pointer",
            b: {
                textDecoration: "none"
            }
        }
    };
});
const Count = styled(Typography)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.text.primary,
        ...theme.typography.subtitle1,
        [theme.breakpoints.down("sm")]: {
            ...theme.typography.subtitle2
        }
    };
});
